import { Anchor, PageAnchorWrapper } from './styled';
import type { AnchorProps } from './styled';

export interface Props extends AnchorProps {
  id: string;
}

const PageAnchor = ({ id, type = 'section-title' }: Props) => {
  return (
    <PageAnchorWrapper>
      <Anchor id={id} type={type} />
    </PageAnchorWrapper>
  );
};

export default PageAnchor;
